import { Box, Flex, Text, Tooltip } from '@mantine/core';
import { Image } from '@unpic/react';
import { ComponentType } from 'react';

import classes from './ConfigTitleBase.module.scss';

export type ConfigTitleBaseProps = {
  title?: string;
  subtitle?: string;
  Icon?: ComponentType<{ width: number; height: number }> | string | null;
};

export function ConfigTitleBase(props: ConfigTitleBaseProps) {
  const { Icon, title, subtitle } = props;

  return (
    <Flex className={classes.wrapper} direction="row">
      {Icon && (
        <Box className={classes.icon}>
          {typeof Icon === 'string' ? (
            <Image
              src={Icon}
              alt={title ?? ''}
              width={20}
              height={20}
              objectFit="cover"
              className={classes.iconImage}
            />
          ) : (
            <Icon width={20} height={20} />
          )}
        </Box>
      )}
      <Flex direction="column">
        <Text className={classes.widgetTitle} span>
          {title}
        </Text>
        <Tooltip multiline position="bottom" label={subtitle}>
          <Text className={classes.subTitle} span>
            {subtitle}
          </Text>
        </Tooltip>
      </Flex>
    </Flex>
  );
}
